<div class="container" *ngIf="passwordResetLinkChecked">
	<div class="title">{{ "NEW_PASSWORD" | translate }}</div>

	<form name="resetPasswordForm" autocomplete="off">
		<!-- a) invalid URL -->
		<ng-container *ngIf="!resetPasswordLinkSeemsValid">
			<p class="error-message">
				{{ 'INVALID_RESET_PASSWORD_LINK' | translate }}
			</p>
			<div class="button-container">
				<bb-button theme="rb" backgroundColor="blue" (click)="logout()">{{ 'SIGN_IN' | translate }}</bb-button>
			</div>
		</ng-container>

		<div *ngIf="resetPasswordLinkSeemsValid">
			<!-- b) user has to set new password -->
			<ng-container *ngIf="!passwordReset">
				<p>{{ 'RESET_PASSWORD_HELP' | translate }}</p>

				<div [ngClass]="{'error': passwordErrorOccured, 'warning': capslockOn}">
					<div [ngClass]="{'error': passwordErrorOccured}">
						<mat-form-field appearance="fill" class="full-width">
							<span matPrefix><i class="far fa-lock"></i></span>
							<mat-label>{{'PASSWORD_NEW' | translate}}</mat-label>
							<input type="password" [(ngModel)]="newPassword" matInput name="password"
								autocomplete="new-password" [ngModelOptions]="{standalone: true}">
						</mat-form-field>
					</div>
				</div>

				<ul class="password-requirements">
					<li>{{ "EIGHT_CHARACTERS_MINIMUM" | translate }}</li>
				</ul>

				<div [ngClass]="{'error': passwordErrorOccured, 'warning': capslockOn}">
					<div [ngClass]="{'error': passwordErrorOccured}">
						<mat-form-field appearance="fill" class="full-width">
							<span matPrefix><i class="far fa-lock"></i></span>
							<mat-label>{{'PASSWORD_NEW_AGAIN' | translate}}</mat-label>
							<input type="password" [(ngModel)]="newPasswordAgain" matInput name="password-repeat"
								autocomplete="new-password" [ngModelOptions]="{standalone: true}"
								(keyup.enter)="resetPassword()">
						</mat-form-field>
					</div>
				</div>

				<p *ngIf="resetPasswordErrorMessage" class="error-message">{{resetPasswordErrorMessage}}.</p>

				<div class="button-container">
					<bb-button theme="rb" backgroundColor="blue" (click)="resetPassword()">{{ 'SAVE' | translate }}</bb-button>
				</div>
			</ng-container>


			<!-- c) user new password has already been set by hash in url -->
			<ng-container *ngIf="passwordReset">
				<p *ngIf="passwordReset">{{ 'CHANGE_PASSWORD_SUCCESS' | translate }}</p>

				<div class="button-container">
					<bb-button theme="rb" backgroundColor="blue" (click)="logout()">{{ 'SIGN_IN' | translate }}</bb-button>
				</div>
			</ng-container>
		</div>
	</form>

	<bb-line-text>
		<a href="https://support.bluebillywig.com/online-video-platform-6-preview/authentication-and-login"
			target="_BLANK">{{ 'NEED_HELP' | translate }}</a>
	</bb-line-text>
</div>
